import { getSportPath } from "./sportWorkspace";

export const COMMUNITY_VIEWS = [
  { id: "trending", label: "Trending" },
  { id: "challenges", label: "Challenges" },
  { id: "battles", label: "Battles" },
  { id: "debates", label: "Debates" },
  { id: "rosters", label: "Rosters" },
];

export const communityAppPath = (sport, rest = "") => {
  const base = getSportPath(sport, "community");
  if (!rest) return base;
  return `${base}${rest.startsWith("/") ? rest : `/${rest}`}`;
};

export const communityBuildPath = (sport, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) query.set(key, value);
  });
  const qs = query.toString();
  return `${communityAppPath(sport, "/build")}${qs ? `?${qs}` : ""}`;
};

export const communityRosterPath = (sport, idOrSlug) =>
  communityAppPath(sport, `/rosters/${encodeURIComponent(idOrSlug)}`);

export const communityMatchupPath = (sport, id) =>
  communityAppPath(sport, `/matchups/${encodeURIComponent(id)}`);

export const communityChallengePath = (sport, idOrSlug) =>
  communityAppPath(sport, `/challenges/${encodeURIComponent(idOrSlug)}`);

export const communityDebatePath = (sport, idOrSlug) =>
  communityAppPath(sport, `/debates/${encodeURIComponent(idOrSlug)}`);

export const communityProfilePath = (sport, handleOrUsername) =>
  communityAppPath(sport, `/creators/${encodeURIComponent(handleOrUsername)}`);

export const communityCreateChallengePath = (sport) =>
  communityAppPath(sport, "/challenges/new");

export const communityCreateDebatePath = (sport, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) query.set(key, value);
  });
  const qs = query.toString();
  return `${communityAppPath(sport, "/debates/new")}${qs ? `?${qs}` : ""}`;
};

export const publicRosterPath = (roster) =>
  roster?.publicPath || (roster?.slug ? `/roster/${roster.slug}` : null);

export const publicMatchupPath = (matchup) =>
  matchup?.publicPath || (matchup?.id ? `/matchup/${matchup.id}` : null);

export const publicChallengePath = (challenge) =>
  challenge?.publicPath ||
  (challenge?.slug ? `/challenge/${challenge.slug}` : null);

export const publicDebatePath = (debate) =>
  debate?.publicPath || (debate?.slug ? `/debate/${debate.slug}` : null);

export const isOfficialDailyDebate = (debate) =>
  Boolean(debate?.kind) ||
  debate?.source === "engine" ||
  debate?.source === "pin";

export const isVotingClosed = (debate) =>
  Boolean(debate?.closesAt) && Date.now() >= new Date(debate.closesAt).getTime();

export const formatRecord = (record) => {
  if (!record) return "0–0";
  return `${record.wins || 0}–${record.losses || 0}`;
};

export const formatWinRate = (record) => {
  if (!record || !(record.wins + record.losses)) return "—";
  return `${Math.round(record.winRate * 100)}%`;
};

export const rosterOwnerLabel = (roster) =>
  roster?.owner?.handle
    ? `@${roster.owner.handle}`
    : roster?.owner?.username || "Fan";

export const filledPlayerNames = (roster, limit = 5) =>
  (roster?.schema?.slots || [])
    .map((slot) => roster?.players?.[slot.id]?.name)
    .filter(Boolean)
    .slice(0, limit);

export const votePercents = (matchup) => {
  const a = Number(matchup?.voteCounts?.rosterA || 0);
  const b = Number(matchup?.voteCounts?.rosterB || 0);
  const total = a + b;
  if (!total) return { a: 0, b: 0, total: 0 };
  return {
    a: Math.round((a / total) * 100),
    b: Math.round((b / total) * 100),
    total,
  };
};

export const playerSearchName = (player) =>
  player?.bio?.displayName ||
  player?.bio?.fullName ||
  player?.bio?.birthName ||
  player?.bioData?.displayName ||
  player?.bioData?.fullName ||
  player?.bioData?.birthName ||
  player?.name ||
  player?.playerId;

export const formatLeaderMeta = (metric, value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount) || !metric?.abbrev) return "";
  return `${amount.toLocaleString()} ${metric.abbrev}`;
};
